var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimelineView = function SvgTimelineView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.75 5.25A.75.75 0 0 0 5 6v12c0 .414.336.75.75.75h13.5A.75.75 0 0 0 20 18V6a.75.75 0 0 0-.75-.75zm.75 12V6.75h12v10.5zm7.5-9H8v1.5h6zm3 6v1.5h-6v-1.5zm-1.5-3h-6v1.5h6z"
  })));
};
export default SvgTimelineView;